
import { Component, Vue } from "vue-property-decorator";
import { SMUser, SMCases } from "@/store";
import { NOTIFICATION_PROPS } from "@/constants/notification";
import { DEPENDANT_INSIDE_SERVICE_TYPE } from "@/constants/services";

@Component({
  components: {
    // TODO: clean up
    // ExpertTemplateDocumentsBrowse: () =>
    //   import(
    //     "@/modules/Services/Template/views/Documents/components/Template/TemplateDocuments/ExpertTemplateDocuments.vue"
    //   ),
    // CandidateTemplateDocumentsBrowse: () =>
    //   import(
    //     "@/modules/Services/Template/views/Documents/components/Template/TemplateDocuments/CandidateTemplateDocuments.vue"
    //   ),
    // NotificationTemplate: () =>
    //   import("@/components/NotificationTemplate/NotificationTemplate.vue"),
    DocumentsTree: () => import("@/modules/Documents/DocumentsTree.vue"),
  },
})
export default class VTemplateDocumentsBrowse extends Vue {
  notificationProps = NOTIFICATION_PROPS;

  get isExpert() {
    return SMUser.isExpert;
  }

  get isEmployee() {
    return SMUser.isEmployee;
  }

  get caseKey() {
    return `${SMCases.caseStepName}-${SMCases.onlineApplicationStatus}`;
  }

  get isDependantCase() {
    return [DEPENDANT_INSIDE_SERVICE_TYPE].includes(SMCases.caseType);
    // return !!((SMCases.case as unknown) as { parent_case_id: number }).parent_case_id;
  }

  get showNotification() {
    return this.isEmployee && !this.isDependantCase;
  }
}
